module.exports = __webpack_public_path__ + "img/calendar-5_fill.8cbd2f59.svg";